import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'colorEncoding';

export class ColorEncoding extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
